import LogRocket from 'logrocket';

// Initialize LogRocket in React Native environment
if (window.ReactNativeWebView) {
  LogRocket.init('kk-szoftver-megoldasok/tshmanagerapp');
  console.log("LogRocket initialized");
}

// Setup user data for LogRocket
async function setupLogRocketUser() {
  try {
    const response = await fetch(`/userinfo`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    });

    if (response.status === 200) {
      const data = await response.json();
      console.log('User info loaded');
      
      if (window.ReactNativeWebView) {
        LogRocket.identify('kk-szoftver-megoldasok/tshmanagerapp', {
          name: data.name,
          email: data.email,
        });
      }
    } else {
      console.log('User is not authenticated');
    }
  } catch (error) {
    console.error('Error loading user info:', error);
  }
}

// Setup LogRocket with user data
setupLogRocketUser(); 